export { default as ErrorBoundaryFallback } from './ErrorBoundaryFallback';
